export default __webpack_public_path__ + "static/media/puntoventa.462a45ea.png";